export default __webpack_public_path__ + "static/media/stationsGasTankCut.3f6e736e.jpg";